/**
 * Scroll reveal.
 *
 * Adds `in-view` to every `.reveal` element as it enters the viewport, which
 * triggers the transition declared in critical.css. Replaces the Framer Motion
 * `ScrollReveal` component from the Astro original with ~30 lines and no
 * runtime dependency.
 *
 * Elements opt into a stagger by setting `--reveal-delay` inline.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(elements) {
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add('in-view');
    }
  }

  function init() {
    var elements = document.querySelectorAll('.reveal:not(.in-view)');
    if (!elements.length) return;

    // No IntersectionObserver, or the visitor asked for less motion: show
    // everything immediately rather than leaving it stuck at opacity 0.
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add('motion-ready');
      observer.observe(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections re-rendered by the theme editor need their new nodes observed.
  document.addEventListener('shopify:section:load', init);
})();
